import './form-container.scss';

import { ConvergeSectionTitle } from './converge-section-title';
import { Grid } from '@mui/material';
import { PropsFor } from '@mui/system';
import { PropsWithChildren } from 'react';

export const FormContainer = (props: PropsFor<typeof Grid>) => {
  return <Grid container spacing={3} columnSpacing={8} {...props} />;
};

export const FormContainerWithHeader = ({
  children,
  title,
  showSeparator = true,
}: PropsWithChildren<{ title: string; showSeparator?: boolean }>) => {
  return (
    <Grid
      item
      sx={{
        '&:not(:last-child)': {
          marginBottom: '30px',
        },
      }}
    >
      <ConvergeSectionTitle
        showSeparator={showSeparator}
        className="converge-section-title"
      >
        {title}
      </ConvergeSectionTitle>
      <FormContainer>{children}</FormContainer>
    </Grid>
  );
};
